'use client';

import { c as _c } from "react/compiler-runtime";
import type { I18n } from '@funkey/locales';
import { createContext, useContext } from 'react';
import { Trans, I18nProvider } from '@lingui/react';
const I18nContext = createContext<I18n>(null!);
export { Trans };
export const I18nContext_Provider: React.FC<{
  i18n: I18n;
  children: React.ReactNode;
}> = props => {
  const $ = _c(6);
  let t0;
  if ($[0] !== props.children || $[1] !== props.i18n) {
    t0 = <I18nProvider i18n={props.i18n}>{props.children}</I18nProvider>;
    $[0] = props.children;
    $[1] = props.i18n;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== props.i18n || $[4] !== t0) {
    t1 = <I18nContext.Provider value={props.i18n}>{t0}</I18nContext.Provider>;
    $[3] = props.i18n;
    $[4] = t0;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};
export const useI18n = () => {
  return useContext(I18nContext);
};